import { Button, Callout, Flex, Link, Text, TextField } from "@radix-ui/themes";
import { useMutation } from "@tanstack/react-query";
import { Formik } from "formik";
import { NavLink } from "react-router-dom";
import * as Yup from "yup";
import { routes } from "../../../routes";
import { AuthRoot } from "../auth-root.component";
import { authClient } from "../client/auth-client";
import { AuthErrorMessage } from "../components/auth-error-message.component";
import { emailValidation } from "../validation/auth-validation";

const requestResetValidationSchema = Yup.object({
  email: emailValidation,
});

export function RequestPasswordResetPage() {
  const requestPasswordResetMutation = useMutation({
    mutationFn: async (input: { email: string }) => {
      await authClient.requestPasswordReset({
        email: input.email,
      });
    },
  });

  return (
    <AuthRoot title="Passwort vergessen">
      {!requestPasswordResetMutation.isSuccess ? (
        <Formik
          initialValues={{ email: "" }}
          validationSchema={requestResetValidationSchema}
          validateOnMount
          onSubmit={(values) => {
            requestPasswordResetMutation.mutate({
              email: values.email,
            });
          }}
        >
          {({
            values,
            errors,
            touched,
            isValid,
            handleBlur,
            handleChange,
            handleSubmit,
          }) => (
            <form onSubmit={handleSubmit}>
              <Flex direction="column" gap="3">
                <Flex direction="column" gap="1">
                  <Text
                    as="label"
                    size="2"
                    weight="medium"
                    htmlFor="request-password-reset-email"
                  >
                    E-Mail
                  </Text>
                  <TextField.Root
                    id="request-password-reset-email"
                    required
                    type="email"
                    size="3"
                    placeholder="E-Mail"
                    name="email"
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {touched.email && errors.email && (
                    <Text size="1" color="red">
                      {errors.email}
                    </Text>
                  )}
                </Flex>
                <Button
                  type="submit"
                  size="3"
                  variant="soft"
                  loading={requestPasswordResetMutation.isPending}
                  disabled={!isValid || requestPasswordResetMutation.isPending}
                >
                  Link senden
                </Button>
              </Flex>
            </form>
          )}
        </Formik>
      ) : (
        <Callout.Root color="green">
          <Callout.Text>
            Falls ein Konto mit dieser E-Mail existiert, erhalten Sie in Kürze
            einen Link zum Zurücksetzen Ihres Passworts.
            <br />
            <br />
            Bitte überprüfen Sie auch Ihren Spam-Ordner.
          </Callout.Text>
        </Callout.Root>
      )}

      {requestPasswordResetMutation.isError && (
        <AuthErrorMessage error={requestPasswordResetMutation.error} />
      )}

      <Link asChild>
        <NavLink to={routes.auth.login}>Zum Login</NavLink>
      </Link>
    </AuthRoot>
  );
}
